/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

/* Import Components*/
import AddCategoryNameIcon from "../../../../components/Settings/CustomCategory/CustomCategoryCreate/AddCategoryNameIcon";
import AddCategoryField from "../../../../components/Settings/CustomCategory/CustomCategoryCreate/AddCategoryField";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SvgComponent from "../../../../components/_utils/SVGComponent";

/*Import Redux*/
import {
  createCustomCategory,
  editCustomCategory,
} from "../../../../redux/features/customCategory";
import {
  getAllCategories,
  resetCategoryData,
} from "../../../../redux/features/sharedResources/sharedResources";
/* IMPORT UTILS */
import TEXT from "../../../../utils/globalText";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const CustomCategoryCreate = ({ flow }) => {
  const isSubmittingRef = useRef(false);
  const divRef = useRef(null);
  const scrollRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bulkUploadCategory = location?.state?.flow;
  const categories = useSelector(
    (state) => state?.sharedResources?.categoriesData?.categories,
  );

  const [selectedCategoryIdForEdit, setselectedCategoryIdForEdit] =
    useState(null);

  /* STATES FOR STEPPER */
  const [activeStep, setActiveStep] = useState(0);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);

  /* STATES FOR STEP 1 */
  const [categoryName, setCategoryName] = useState(
    bulkUploadCategory ? TEXT?.BULK_UPLOAD : "",
  );
  const [categoryDescription, setCategoryDescription] = useState("");
  const [categoryIcon, setCategoryIcon] = useState("");
  const [previousCategoryIcon, setPreviousCategoryIcon] = useState("");
  const [iconColor, setIconColor] = useState("");
  const [previousIconColor, setPreviousIconColor] = useState("");
  const [previousCategoryName, setPreviousCategoryName] = useState("");
  const [previousCategoryDescription, setPreviousCategoryDescription] =
    useState("");

  /* STATES FOR STEP 2 */
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [toggleDescription, setToggleDescription] = useState("");
  const [fieldMandatory, setFieldMandatory] = useState(false);
  const [options, setOptions] = useState([{ id: Date.now(), value: "" }]);

  const [fieldDetails, setFieldDetails] = useState([]);
  const [previousFieldDetails, setPreviousFieldDetails] = useState([]);
  const [isClearActive, setIsClearActive] = useState(false);
  const [isConfirmActive, setIsConfirmActive] = useState(false);
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [step2NextBtnEnabled, setStep2NextBtnEnabled] = useState(false);
  /* STATES FOR DELETING FIELD */
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteFieldIndex, setDeleteFieldIndex] = useState();
  const [showLoader, setShowLoader] = useState(false);

  const trimmedCategoryName = categoryName?.trim() || "";
  const trimmedCategoryDescription = categoryDescription?.trim() || "";

  const filteredCategory = categories?.some(
    (category) =>
      category?.name?.toLowerCase() === categoryName?.trim()?.toLowerCase(),
  );

    const prefilledFieldData = Array.from(
      { length: GlobalConfiguration?.lengthCheckThree },
      (_, index) => ({
        name: `Custom field ${index + GlobalConfiguration?.lengthCheckOne}`,
        position: index + GlobalConfiguration?.lengthCheckOne,
        data_type: "string",
        mandatory: "N",
      }),
    );
  const checkNewBulkUpload = categoryName?.trim()?.toLowerCase() ===
        TEXT?.BULK_UPLOAD?.toLowerCase()

  const isCreateBulkUploadExist = ( checkNewBulkUpload &&
        !bulkUploadCategory &&
        flow !== "edit") ||
      (flow === "edit" &&
        !bulkUploadCategory &&
        previousCategoryName?.trim().toLowerCase() !== "bulk upload" &&
        checkNewBulkUpload)

  const isFirstStepValid =
    activeStep === GlobalConfiguration?.lengthCheckZero &&
    categoryName &&
    categoryDescription &&
    categoryIcon;

  const isEditFirstStepEnabled =
    activeStep === GlobalConfiguration?.lengthCheckZero &&
    trimmedCategoryName.length >= GlobalConfiguration?.categoryminLength &&
    trimmedCategoryDescription.length >= GlobalConfiguration.categoryminLength;

  /* Array comprising of steps for PrimaryStepper component */
  const dataArray = [
    {
      previousText:TEXT?.CANCEL,
      nextText:TEXT?.NEXT,
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: TEXT?.WHITE,
      nextHoverOption:TEXT?.BLACK,
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: nextButtonEnabled,
      stepperText:TEXT?.ENTER_CATEGORY_NAME_AND_SELECT_ICON,
    },
    {
      previousText: TEXT?.PREVIOUS,
      nextText: flow === TEXT?.EDIT?.toLowerCase() ? TEXT?.UPDATE: TEXT?.CREATE,
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: TEXT?.WHITE,
      nextHoverOption: TEXT?.BLACK,
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: step2NextBtnEnabled,
      stepperText: TEXT?.SETUP_ADDITIONAL_DETAILS,
      extraInfoSubText: TEXT?.ADDITIONAL_DETAILS_DESCRIPTION,
      extraInfoShow: true,
    },
  ];
  const handleNext = () => {
    if (filteredCategory) {
      CommonToast({
        text: TEXT?.REDUNDANT_BULK_UPLOAD_CATEGORY,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return;
    }
    if (isFirstStepValid) {
      setActiveStep(
        (prevActiveStep) =>
          prevActiveStep + GlobalConfiguration?.lengthCheckOne,
      );
    } else if (activeStep === GlobalConfiguration?.lengthCheckOne) {
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      setStep2NextBtnEnabled(false);

      (async () => {
        try {
          await createCategory();
        } catch (err) {
          setStep2NextBtnEnabled(true);
        } finally {
          isSubmittingRef.current = false;
        }
      })();
    }
  };

  const handleBack = () => {
    setEditIndex(null);
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(GlobalConfiguration?.navigate_back);
    } else {
      setActiveStep(
        (prevActiveStep) =>
          prevActiveStep - GlobalConfiguration?.lengthCheckOne,
      );
    }
  };

  const createCategory = async () => {
    let response = null;
    if (flow === TEXT?.EDIT?.toLowerCase()) {
      response = await dispatch(
        editCustomCategory({
          id: selectedCategoryIdForEdit,
          name: categoryName,
          description: categoryDescription,
          configuration: fieldDetails?.length ? fieldDetails : null,
          asset_properties: { resource_name: categoryIcon, colour: iconColor },
        }),
      );
    } else {
      response = await dispatch(
        createCustomCategory({
          name: bulkUploadCategory ? TEXT?.BULK_UPLOAD : categoryName,
          description: categoryDescription,
          configuration: fieldDetails?.length ? fieldDetails : null,
          asset_properties: { resource_name: categoryIcon, colour: iconColor },
        }),
      );
    }
    if (response?.payload?.status === true) {
      if (bulkUploadCategory === "bulk_transactions") {
        navigate(
          `/settings/category_dashboard/view_details/${
            response?.payload?.categories[GlobalConfiguration.lengthCheckZero]?.id
          }`,
          {
            replace: true,
            state: {
              flow: bulkUploadCategory,
            },
          },
        );
      } else {
        navigate("/settings/category_dashboard", {
          state: {
            filteredData: location?.state?.filteredData,
          },
        });
      }
      CommonToast({
        text:
          flow === TEXT?.EDIT?.toLowerCase()
            ? TEXT?.CATEGORY_UPDATE_SUCCESS
            : TEXT?.CATEGORY_CREATE_SUCCESS,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else {
      setStep2NextBtnEnabled(true);
      const errors = response?.payload?.errors;
      if (errors?.name) {
        CommonToast({
          text: errors?.message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.configuration) {
        CommonToast({
          text: errors?.configuration?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.token_expired) {
        CommonToast({
          text: errors?.token_expired?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.user_unauthorized) {
        CommonToast({
          text: errors?.user_unauthorized?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (errors?.asset_properties) {
        CommonToast({
          text: errors?.asset_properties?.[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const deleteField = (fieldIndexToDelete) => {
    setShowLoader(true);
    setTimeout(() => {
      setFieldDetails((prevFields) => {
        // Remove the item by index
        const updatedFields = prevFields.filter(
          (_, index) => index !== fieldIndexToDelete,
        );

        // Reassign sequential positions
        const reindexedFields = updatedFields.map((field, index) => ({
          ...field,
          position: index + 1,
        }));

        return reindexedFields;
      });

      setShowDeletePopup(false);
      setShowLoader(false);
    }, 500);
  };

  const handleScrollToBottom = () => {
    const element = scrollRef.current;

    if (!element) return;

    element.scrollTo({
      top: element.scrollHeight,
      behavior: "smooth",
    });
  };

  const renderCustomCategoryCreateSteps = () => {
    switch (activeStep) {
      case GlobalConfiguration.lengthCheckZero:
        return (
          <AddCategoryNameIcon
            flow={bulkUploadCategory}
            categoryName={categoryName}
            setCategoryName={setCategoryName}
            categoryDescription={categoryDescription}
            setCategoryDescription={setCategoryDescription}
            categoryIcon={categoryIcon}
            setCategoryIcon={setCategoryIcon}
            iconColor={iconColor}
            setIconColor={setIconColor}
            filteredCategory={filteredCategory}
            previousCategoryName={previousCategoryName}
          />
        );
      case GlobalConfiguration.lengthCheckOne:
        return (
          <AddCategoryField
            isAddButtonClicked={isAddButtonClicked}
            setIsAddButtonClicked={setIsAddButtonClicked}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            fieldName={fieldName}
            setFieldName={setFieldName}
            fieldType={fieldType}
            setFieldType={setFieldType}
            toggleDescription={toggleDescription}
            setToggleDescription={setToggleDescription}
            fieldMandatory={fieldMandatory}
            setFieldMandatory={setFieldMandatory}
            options={options}
            setOptions={setOptions}
            fieldDetails={fieldDetails}
            setFieldDetails={setFieldDetails}
            isClearActive={isClearActive}
            setIsClearActive={setIsClearActive}
            isConfirmActive={isConfirmActive}
            setIsConfirmActive={setIsConfirmActive}
            showDeletePopup={showDeletePopup}
            setShowDeletePopup={setShowDeletePopup}
            showLoader={showLoader}
            setDeleteFieldIndex={setDeleteFieldIndex}
            fieldDataArrayAreSimilar={fieldDataArrayAreSimilar}
            flow={
              bulkUploadCategory
                ? "bulk_transactions"
                : TEXT?.EDIT?.toLowerCase()
            }
            scrollRef={scrollRef}
            handleScrollToBottom={handleScrollToBottom}
            previousCategoryName={previousCategoryName}
            categoryName={categoryName}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (flow === TEXT?.EDIT?.toLowerCase()) {
      setselectedCategoryIdForEdit(location?.state.id);

      setCategoryName(location?.state?.name?.trim());
      setPreviousCategoryName(location?.state?.name?.trim());

      setCategoryDescription(location?.state?.description?.trim());
      setPreviousCategoryDescription(location?.state?.description?.trim());

      setCategoryIcon(location?.state?.asset_properties?.resource_name);
      setPreviousCategoryIcon(location?.state?.asset_properties?.resource_name);

      setIconColor(
        `${location?.state?.asset_properties?.colour?.replaceAll("_", "-")}` ||
          "Custom-Category-Blue",
      );
      setPreviousIconColor(location?.state?.asset_properties?.colour);

      setFieldDetails(location?.state?.configuration?.data || []);
      setPreviousFieldDetails(location?.state?.configuration?.data || []);
    }
  }, [location, flow, bulkUploadCategory]);

  useEffect(() => {
    if (
      bulkUploadCategory === "bulk_transactions" ||
      categoryName?.toLowerCase() === TEXT?.BULK_UPLOAD?.toLowerCase()
    ) {
      setFieldDetails(prefilledFieldData);
    }
  }, [bulkUploadCategory, categoryName]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        await dispatch(getAllCategories());
      } catch (error) {
        console.error(error);
      }
    };

    if (
      isCreateBulkUploadExist
    ) {
      fetchCategories();
    }
  }, [dispatch, categoryName]);

  // Deep equality that treats object key order as irrelevant but requires array order to match.
  const arraysEqualInSequence = (a, b) => {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length)
      return false;

    const deepEqual = (x, y) => {
      if (x === y) return true;
      if (x == null || y == null) return false;

      if (Array.isArray(x) && Array.isArray(y)) {
        if (x.length !== y.length) return false;
        return x.every((v, i) => deepEqual(v, y[i]));
      }

      if (typeof x === "object" && typeof y === "object") {
        const keysX = Object.keys(x),
          keysY = Object.keys(y);
        if (keysX.length !== keysY.length) return false;
        return keysX.every((k) => keysY.includes(k) && deepEqual(x[k], y[k]));
      }

      return false;
    };

    return a.every((item, i) => deepEqual(item, b[i]));
  };

  const fieldDataArrayAreSimilar = useMemo(
    () => arraysEqualInSequence(fieldDetails, previousFieldDetails),
    [fieldDetails, previousFieldDetails],
  );

  const isEditSecondStepEnabled =
    (activeStep === GlobalConfiguration?.lengthCheckOne &&
      (previousCategoryName !== trimmedCategoryName ||
        previousCategoryDescription !== trimmedCategoryDescription ||
        previousCategoryIcon !== categoryIcon || iconColor !== previousIconColor)
    ) || (!arraysEqualInSequence(fieldDetails, previousFieldDetails) && editIndex === null)
  
  const isCreateFirstStepEnabled = activeStep === GlobalConfiguration?.lengthCheckZero &&
        categoryName?.trim()?.length >= GlobalConfiguration?.categoryminLength &&
        categoryDescription?.trim()?.length >= GlobalConfiguration?.categoryminLength &&
    categoryIcon
  const isCreateSecondStepEnabled =  activeStep === GlobalConfiguration?.lengthCheckOne &&
        editIndex !== null &&
        editIndex !== undefined

  useEffect(() => {
    if (isSubmittingRef.current) return;

    let shouldEnableNextButton = false;
    let shouldEnableStep2NextButton = false;

    if (flow === TEXT?.EDIT?.toLowerCase()) {
      shouldEnableNextButton = isEditFirstStepEnabled;

      shouldEnableStep2NextButton =
        isEditSecondStepEnabled && editIndex === null && !isAddButtonClicked;
    } else {
      if (isCreateFirstStepEnabled) {
        shouldEnableNextButton = true;
      } else if (isCreateSecondStepEnabled) {
        shouldEnableStep2NextButton = false;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        !isAddButtonClicked
      ) {
        shouldEnableStep2NextButton = true;
      }
    }

    setNextButtonEnabled(shouldEnableNextButton);
    setStep2NextBtnEnabled(shouldEnableStep2NextButton);
  }, [
    flow,
    activeStep,
    isEditFirstStepEnabled,
    isEditSecondStepEnabled,
    isCreateFirstStepEnabled,
    isCreateSecondStepEnabled,
    editIndex,
    isAddButtonClicked,
  ]);

  useEffect(() => {
    dispatch(resetCategoryData());
  }, []);

  return (
    <>
      {showDeletePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={TEXT?.CONFIRM_DELETE_FIELD}
            headerFontColor="var(--custom-orange)"
            subtext={TEXT?.DELETE_FIELD_DESCRIPTION}
            btnOneText={TEXT?.CANCEL}
            btnOneBtnType={TEXT?.BUTTON}
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowDeletePopup(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={TEXT?.DELETE}
            btnTwoBtnType={TEXT?.BUTTON}
            btnTwoHandleFunction={() => deleteField(deleteFieldIndex)}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption={TEXT?.BLACK}
          />
        </div>
      )}

      {/*--------------------------*/}

      {/* STEPPER and the associated steps */}
      <div className="w-width-full flex items-center flex-col bg-primary-bg h-screen overflow-y-hidden">
        {/*Responsive Screen Header or Navbar*/}
        <div className="add-category-responsive-screen-header sticky top-top-base flex flex-col Qsmd:hidden py-padding-sm bg-primary-nav w-width-full z-z-index-header">
          <div className="flex">
            <div
              className="flex items-center justify-center cursor-pointer px-padding-md"
              onClick={handleBack}
            >
              <SvgComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
                color={"var(--text-primary)"}
                alt={TEXT?.BACK_TO_PREVIOUS_STEP}
              />
            </div>
            <div className="flex flex-col justify-center gap-y-gap-xs">
              <p className="text-font-md text-text-primary font-normal">
                {flow === TEXT?.EDIT?.toLowerCase()
                  ? TEXT?.EDIT_CATEGORY
                  : TEXT?.ADD_CATEGORY}
              </p>
              <p className="text-font-xs text-text-secondary font-semibold">
                {dataArray[activeStep]?.stepperText}
              </p>
            </div>
          </div>

          {/* STEPPER: STEP 2 CONDITIONAL  DIV*/}
          {activeStep === GlobalConfiguration?.lengthCheckOne ? (
            <div className="bg-primary-nav w-width-full mt-margin-sm Qsmd:hidden">
              <div className="mx-auto max-w-tab-width-normal pt-padding-md pb-padding-sm Qmd:py-padding-sm px-padding-sm Qmd:px-padding-base border-t border-solid border-primary-bg">
                <p className="text-font-xs text-text-secondary font-normal">
                  {TEXT.ADDITIONAL_DETAILS_DESCRIPTION}
                </p>
              </div>
            </div>
          ) : null}
        </div>

        <div className="w-full h-navbar-breadcrumb-height hidden Qsmd:flex flex-shrink-0 Qlg:bg-transparent bg-primary-nav"></div>

        <div
          ref={divRef}
          className={`custom-category-create-stepper w-width-full fixed bottom-bottom-base z-z-index-dropdown Qsmd:relative  ${activeStep === GlobalConfiguration?.lengthCheckOne ? "Qsmd:min-h-card-height min-h-topnavbar-min-height" : "h-stepper-moble-height"}`}
        >
          <div className="mx-auto max-w-tab-width-normal">
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={handleNext}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>
        {<>{renderCustomCategoryCreateSteps()}</>}
      </div>
      {/*------------------------------*/}
    </>
  );
};

export default CustomCategoryCreate;
